module.exports = __webpack_public_path__ + "static/media/loader.b535e059.svg";